"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const maxValueToCheck = 100;
function default_1() {
    if (!matchMedia('(min-monochrome: 0)').matches) {
        return 0;
    }
    for (let i = 0; i <= maxValueToCheck; i++) {
        if (matchMedia(`(max-monochrome: ${i})`).matches) {
            return i;
        }
    }
    throw new Error('Too high value');
}
exports.default = default_1;
